<template>
  <div id="app">
    <div v-if="loading" class="page-loader">
      <div class="loader-content">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="40" height="40" class="loader-icon">
          <path fill="currentColor" d="M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"/>
        </svg>
        <span>FM Radio</span>
      </div>
    </div>

    <SiteHeader v-show="!loading" :scrollToSection="scrollToSection" />
    <main v-show="!loading">
      <section ref="home" id="home">
        <Hero />
      </section>
      <section ref="features" id="features">
        <Features />
      </section>
      <section ref="download" id="download">
        <Download />
      </section>
    </main>
    <SiteFooter v-show="!loading" />
  </div>
</template>

<script>
import SiteHeader from './components/Header.vue'
import Hero from './components/Hero.vue'
import Features from './components/Features.vue'
import Download from './components/Download.vue'
import SiteFooter from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    SiteHeader,
    Hero,
    Features,
    Download,
    SiteFooter
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    scrollToSection(sectionId) {
      const section = this.$refs[sectionId];
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  },
  mounted() {
    // 确保组件已经准备好后再加载
    window.addEventListener('load', () => {
      // 延长加载时间，确保组件完全渲染
      setTimeout(() => {
        this.loading = false;
      }, 1500)
    });
  }
}
</script>

<style>
#app {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1e293b;
  max-width: 100%;
  overflow-x: hidden;
}

.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0f172a, #1e293b);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.loader-icon {
  color: #3b82f6;
  animation: pulse 1.5s infinite ease-in-out alternate;
}

.loader-content span {
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
  letter-spacing: 1px;
  animation: fadeIn 2s ease;
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.2);
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  scroll-padding-top: 80px; /* 为固定导航栏设置滚动偏移 */
}

body {
  background-color: #f8fafc;
}

main {
  width: 100%;
  padding-top: 80px; /* 为固定的顶部导航栏留出空间 */
}

#home, #features, #download {
  scroll-margin-top: 80px; /* 为锚点导航设置边距 */
}

:root {
  --primary-color: #2578e9;
  --primary-dark: #1a5cbf;
  --primary-light: #4ac7fa;
  --secondary-color: #0f172a;
  --text-color: #1e293b;
  --text-light: #64748b;
  --background-color: #f8fafc;
}

@media (max-width: 992px) {
  main {
    padding-top: 70px;
  }
  
  html {
    scroll-padding-top: 70px;
  }
  
  #home, #features, #download {
    scroll-margin-top: 70px;
  }
}

@media (max-width: 640px) {
  main {
    padding-top: 60px;
  }
  
  html {
    scroll-padding-top: 60px;
  }
  
  #home, #features, #download {
    scroll-margin-top: 60px;
  }
}
</style>
